var _circle, _circle2, _circle3, _circle4, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMyPostionBearingIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 61,
    viewBox: "0 0 45 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.0234,
    cy: 39,
    r: 22,
    fill: "url(#paint0_radial_20103_539052)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 22.0234,
    cy: 39,
    r: 13,
    fill: "url(#paint1_radial_20103_539052)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 22.0039,
    cy: 39,
    r: 11,
    fill: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 22.0234,
    cy: 39,
    r: 7,
    fill: "#0047FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.7305 36.6804C23.1703 33.6737 20.8927 33.5723 19.2799 36.6804L9.46875 3.93005C17.7003 -0.0248205 26.3101 -0.0249044 34.5416 3.93006L24.7305 36.6804Z",
    fill: "url(#paint2_linear_20103_539052)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_20103_539052",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.0234 39) rotate(90) scale(51.5083)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0047FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453125,
    stopColor: "#0047FF",
    stopOpacity: 0.04
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_20103_539052",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.0234 39) rotate(90) scale(30.4367)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.192708,
    stopColor: "#0047FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.395833,
    stopColor: "#0047FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#0047FF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#0047FF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.755208,
    stopColor: "#0047FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_20103_539052",
    x1: 22.0051,
    y1: 36.6804,
    x2: 22.0056,
    y2: 0.963867,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0047FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#0047FF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.588542,
    stopColor: "#0047FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828125,
    stopColor: "#0047FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0047FF",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyPostionBearingIcon);
export default __webpack_public_path__ + "static/media/myPostionBearingIcon.0ac26a746919964e779e6b3c2b029229.svg";
export { ForwardRef as ReactComponent };